<template style='text-align:left'>

  <v-layout column>
   
    <v-flex xs12>
      <v-layout row  py-0 my-0>
        <v-flex xs5 mx-2 pt-2> 
          <v-card color="indigo" dark flat>
            <EditDateMaybeRange v-bind:container='bio' v-bind:dateProp="'date'"/>
            <!-- input type="date" v-model="bio.date"/ -->
          </v-card>
        </v-flex>
        <v-flex xs6 mx-0 pt-0 v-if="bio.beTemplateId <= 0">       
            <v-autocomplete v-model="bio.beTemplateId" :items="$constants.bioEntyTemplateSelectors"
            flat solo :label="'Select event'" background-color='#ffdddd' :auto-select-first="true"
            item-text="v" item-value="id" single-line  @change="templateChange()"></v-autocomplete>             
        </v-flex>
        <v-flex xs6 mx-0 pt-0 v-else>
          <div style='font-size:120%;font-weight:bold;color:indigo;padding-left:10px;margin-top:5px'>{{ $constants.decodedBioEntries[bio.beTemplateId][0].s }}</div>
        </v-flex>

        <v-flex xs1 mx-0 pt-3>  
          <v-icon v-if="!bio.note" small  @click='addNote()'>note_add</v-icon>
        </v-flex>
      </v-layout>
      <v-layout row v-if="steps && (steps.length > 0)" >
        <!-- v-flex xs12 mx-2 v-html='detail()'></v-flex -->      

        <v-flex ml-4 xs12  py-0 my-0>
          <div v-for="(step, index) in steps.slice(1)" v-bind:key="index">
            <span v-if="step.type === 's'"><!--{{step.s}}--></span>
            <div v-else-if="step.type === 'd'">
              <span v-if="step.prompt">{{step.prompt}}: </span>
                <input type="date" v-model="bio[step.prop]"/>
            </div>
            <div v-else-if="step.type === 't'"> <input type="datetime-local" v-model="bio[step.prop]" @change="dateTimeChange"/></div>
            <div v-else-if="step.type === 'c'"> 
              <!-- code: {{step.code}} step fld: {{step.fld}} myid: {{bio[step.fld][0].id}} -->
              <v-autocomplete v-model="bio[step.fld]" :items="$constants.codeValues[step.code]" 
              :label="`${$constants.codes.find(x => x.code === step.code).v}`" :auto-select-first="true"
              item-text="v" item-value="id" return-object>
              </v-autocomplete> 
            </div>
            <div v-else-if="step.type === 'p'">
              <div v-if="bio[step.prop]">
                <EditPlace v-bind:place='bio[step.prop]' v-bind:prompt="step.prompt" v-bind:container='bio' v-bind:containerProp='step.prop'/>
              </div>
              <div v-else>
                  <label class='prompt'>Place</label><v-btn flat fab  small mt-4  middle @click='addSinglyOccuringNoncodeProp(step.prop, {rid: -1})'><v-icon>add</v-icon></v-btn> 
              </div>
            </div>    
            <div v-else-if="step.type === 'u'">
              <div v-if="bio[step.prop]">
                <EditUnit v-bind:unit='bio[step.prop]' v-bind:prompt="step.prompt"/>
              </div>  
              <div v-else>
                  <label class='prompt'>Unit</label><v-btn flat fab  small mt-4  middle @click='addSinglyOccuringNoncodeProp(step.prop, {rid: -1})'><v-icon>add</v-icon></v-btn> 
              </div>
            </div>
            <div v-else-if="step.type === 'r'">
               <div v-if="bio[step.prop]">
                <EditRank v-bind:rank='bio[step.prop]' v-bind:person='person' v-bind:prompt="step.prompt"/>
              </div>  
              <div v-else>
                  <label class='prompt'>Rank</label><v-btn flat fab  small mt-4  middle @click='addSinglyOccuringNoncodeProp(step.prop, {rid: -1})'><v-icon>add</v-icon></v-btn> 
              </div>                
            </div>              
            <div v-else-if="step.type === 'x'">
              <div v-if="bio[step.prop]">
                <v-textarea v-model="bio[step.prop][step.fld]" :label="`${step.prompt}`"  p rows="3" />
              </div>
              <div v-else>
                 <label class='prompt'>{{step.prompt}}</label><v-btn flat fab  small mt-4  middle @click='addSinglyOccuringNoncodeProp(step.prop, {rid: -1})'><v-icon>add</v-icon></v-btn> 
              </div> 
            </div>  
            <div v-else-if="step.type === 'y'">
              <div v-if="bio.serviceDays">
                <B>Length of Service</B> <EditLengthOfService v-bind:container='bio' v-bind:prop="'serviceDays'"/>
                <!-- v-textarea v-model="bio.serviceDays" :label="`${step.prompt}`"  p rows="1" />  TODO make edit control years days -->
              </div>
              <div v-else>
                 <label class='prompt'>{{step.prompt}}</label><v-btn flat fab  small mt-4  middle @click='addSinglyOccuringNoncodeProp("serviceDays", 366)'><v-icon>add</v-icon></v-btn> 
              </div> 
            </div>              
            <span v-else-if="step.type === ':'"></span>
            <div v-else>
                Cant edit type step: {{step.type}} yet
            </div>                 
          </div>
        </v-flex>
      </v-layout>
      <v-layout v-if="bio.note">
        <v-flex ml-4 xs11  py-0 my-0>
           <v-textarea v-model="bio.note" :label="'Note'"  p rows="3" />
        </v-flex>
        <v-flex xs1  >       
          <v-icon  small @click='delNote()' >delete</v-icon>
        </v-flex>
      </v-layout> 
    </v-flex>  
  </v-layout>
</template>        

<script>

import EditPlace from "./EditPlace" ; 
import EditUnit from "./EditUnit" ; 
import EditRank from "./EditRank" ; 
import EditDateMaybeRange from "./EditDateMaybeRange" ; 
import EditLengthOfService from "./EditLengthOfService" ;

export default {

  components: { EditPlace, EditUnit, EditRank, EditDateMaybeRange, EditLengthOfService },
  props: {
    bio: null,
    person: null
  },

  data () {
    return {
      steps: null
    }
  },

  /*
  watch: {
    bio: function (oldVal, newVal) {
      console.log("- - - - - - ^^^^^EditBio bio prop CHANGED from " + JSON.stringify(oldVal) + " to " + JSON.stringify(newVal)) ;
      this.checkBioEntryForMissingPropsAndInitialiseToEmpty(newVal) ;
    }
  },
  */

  async created () {
    // console.log("In editBio created") ;
    // console.log("*********0000In editBio created, bio prop is " + JSON.stringify(this.bio)) ;
    if (this.bio.beTemplateId > 0)
      this.steps = this.$constants.decodedBioEntries[this.bio.beTemplateId] ;
    // console.log(" STEPS :" + JSON.stringify(this.steps)) ;
    // console.log("OFF TO checkBioEntryForMissingPropsAndInitialiseToEmpty") ;
    // this.checkBioEntryForMissingPropsAndInitialiseToEmpty(this.bio) ;
    // console.log("BACK FROM checkBioEntryForMissingPropsAndInitialiseToEmpty") ;
  },

  async mounted () {
    // console.log("EDITBIO mounted this.bio.beTemplateId=" + this.bio.beTemplateId + ", this.templates=" + JSON.stringify(this.templates)) ;    
  },

  methods: {

    dateTimeChange () {
      console.log("dateTimeChange  for bio " + JSON.stringify(this.bio)) ;
    },

    date () {
      return (this.bio.date) ? this.$dateFormatFromYMD(this.bio.date) : "<span class='lite'>undated&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>"
    },

    heading () {
      if (!this.steps || (this.steps.length < 1)) return "Unknown" ;
      const step1 = this.steps[0] ;
      if (step1.type !== 's') return "" ;
      return step1.s ;
    },

    templateChange (val) {
      console.log("template change to " + this.bio.beTemplateId + " val was " + val) ;
      this.steps = this.$constants.decodedBioEntries[this.bio.beTemplateId] ;
      console.log(" our steps are now " + JSON.stringify(this.steps)) ;
      this.createSkeletalBioEntry(this.bio.date) ;
      this.id = -1 ;
      this.$forceUpdate() ;   // shouldnt have to do this.
    },

    /*
    checkBioEntryForMissingPropsAndInitialiseToEmpty (bio) {

      console.log("IN checkBioEntryForMissingPropsAndInitialiseToEmpty") ;
      if (this.steps !== null) {

        for (let i = 0 ; i < this.steps.length ; i++) {

          const step = this.steps[i] ;
          switch (step.type) {
            case 's':
            case ':': break ; // string or string prefix...
            case 'd': // date
            case 't': // datetime
              break ;
            case 'c': // code
              if (!bio[step.fld]) bio[step.fld] = {"rid": -1, "id": -1, "v" :""} ;
              break ;
            case 'r': // rank
            case 'u': // unit
              if (!bio[step.prop]) bio[step.prop] = {"rid": -1, "id": -1, "v" :""} ;
              break ;
            case 'p': // place
              console.log(" PLACE STEP, bio has prop: " + step.prop + " - place: " + JSON.stringify(bio[step.prop])) ;
              if (!bio[step.prop]) bio[step.prop] =  {"rid":-1, "town": {"id":-1, "v":null}, "state": {"id": -1, "v":null}, "country": {"id": -1, "v":null}} ;
              this.$forceUpdate() ;
              break ;
            case 'x': // text
              if (!bio[step.prop]) bio[step.prop] =  {"rid": -1} ;
              break ;
            default:
              console.log("Dont know how to process step " + JSON.stringify(step) + " in EditBio checkBioEntryForMissingPropsAndInitialiseToEmpty ") ;
          }
        }
      }
    },
    */

    createSkeletalBioEntry (defaultDate) {

      // go through the steps adding any needed minimal props.  Any existing props are left as is (!  TODO !?)

      for (let step of this.steps) {
        switch (step.type) {
          case 's': break ; // string
          case 't':
            if (!this.bio[step.prop] && defaultDate) {              
              let i = defaultDate.indexOf(" -") ;
              if (i > 0) defaultDate = defaultDate.substring(0, i) ;
              this.bio[step.prop] = defaultDate + "T09:00" ;
            }
            break ;
          case 'd':
            if (!this.bio[step.prop] && defaultDate) {
              let i = defaultDate.indexOf(" -") ;
              this.bio[step.prop] = (i > 0) ? defaultDate.substring(0, i) : defaultDate ;
            }
            break ;            
          case 'p':
            if (!this.bio[step.prop]) this.bio[step.prop] = {"rid":-1, "town": {"id":-1, "v":null}, "state": {"id": -1, "v":null}, "country": {"id": -1, "v":null}} ;
            break ;
          case 'u':
            if (!this.bio[step.prop]) this.bio[step.prop] = {"rid": -1, "id": -1, "v" :""} ;
            break ;
          case 'r':
            if (!this.bio[step.prop]) this.bio[step.prop] = {"rid": -1, "id": -1, "v" :""} ;
            break ; 
          case 'c':
            if (!this.bio[step.fld]) this.bio[step.fld] = {"rid": -1, "id": -1, "v" :""} ; // was an array, I know..
            break ;   
          case 'x':
            if (!this.bio[step.prop]) {
              const textVal = {"rid": -1}   ;
              textVal[step.fld] = "" ; // typically sv1
              this.bio[step.prop] = textVal ;
            }
            break ; 
          case ':': // dummy prompt step - ignire
            break ;                      
          default:
            console.log("createSkeletalBioEntry didnt understand step " + JSON.stringify(step)) ;
        }
      }
    },

    delNote () {
      delete this.bio.note ;
      this.$forceUpdate() ;
    },

    addNote () {
      this.bio.note = " " ;
      this.$forceUpdate() ;
    },

    addSinglyOccuringNoncodeProp (propName, defaultValue) {
      this.bio[propName] = defaultValue ;
      this.$forceUpdate() ;   // shouldnt have to do this..
    }
  }
}
</script>

<style>
.lite {color:#aaaaaa} ;
</style>



// WEBPACK FOOTER //
// src/components/Person/EditBio.vue